function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import moment from 'moment-timezone';
import { formatCurrency, removeTypename } from 'shared/helpers/utils';
import { getSpecialHoursDays, getEnabledV2OrderTypes, openInfoForDispensary } from 'shared/core/helpers/dispensaries';
import { mutuallyInclusiveFeatures, defaultCategoryPhotos } from 'shared/constants';
export var getOpenNowStatus = function(openInfo) {
    var _openInfo_pickup, _openInfo_delivery, _openInfo_inStorePickup, _openInfo_driveThruPickup, _openInfo_curbsidePickup;
    return ((_openInfo_pickup = openInfo.pickup) === null || _openInfo_pickup === void 0 ? void 0 : _openInfo_pickup.isOpen) || ((_openInfo_delivery = openInfo.delivery) === null || _openInfo_delivery === void 0 ? void 0 : _openInfo_delivery.isOpen) || ((_openInfo_inStorePickup = openInfo.inStorePickup) === null || _openInfo_inStorePickup === void 0 ? void 0 : _openInfo_inStorePickup.isOpen) || ((_openInfo_driveThruPickup = openInfo.driveThruPickup) === null || _openInfo_driveThruPickup === void 0 ? void 0 : _openInfo_driveThruPickup.isOpen) || ((_openInfo_curbsidePickup = openInfo.curbsidePickup) === null || _openInfo_curbsidePickup === void 0 ? void 0 : _openInfo_curbsidePickup.isOpen);
};
export var getNextServiceOpenString = function(openInfo) {
    var pickup = openInfo.pickup, delivery = openInfo.delivery;
    if (pickup.nextService.openMoment && delivery.nextService.openMoment) {
        return pickup.nextService.openMoment.isBefore(delivery.nextService.openMoment) ? pickup.nextService.openString : delivery.nextService.openString;
    }
    if (!pickup.nextService.openMoment && delivery.nextService.openMoment) {
        return delivery.nextService.openString;
    }
    return pickup.nextService.openString;
};
export var getNextOpenService = function(dispensary) {
    var openInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, includeDelivery = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var enabledServices = getEnabledV2OrderTypes(dispensary);
    var openInfoToUse = openInfo || openInfoForDispensary(dispensary);
    var filteredEnabledServices = includeDelivery ? enabledServices : _.without(enabledServices, 'delivery');
    var nextOpenService = 'inStorePickup';
    if (filteredEnabledServices.length === 0) {
        return nextOpenService;
    }
    var ref;
    ref = _sliced_to_array(filteredEnabledServices, 1), nextOpenService = ref[0], ref; // assign the nextOpenService as the first enabled type
    var enabledOrderTypeOpenMoments = _.compact(_.map(filteredEnabledServices, function(service) {
        var _openInfoToUse_service;
        return (_openInfoToUse_service = openInfoToUse[service]) === null || _openInfoToUse_service === void 0 ? void 0 : _openInfoToUse_service.nextService.openMoment;
    }));
    if (enabledOrderTypeOpenMoments.length === 0) {
        return nextOpenService;
    }
    var nextOpenServiceMoment = moment.min(enabledOrderTypeOpenMoments);
    nextOpenService = _.find(filteredEnabledServices, function(service) {
        var _openInfoToUse_service;
        return nextOpenServiceMoment.isSame((_openInfoToUse_service = openInfoToUse[service]) === null || _openInfoToUse_service === void 0 ? void 0 : _openInfoToUse_service.nextService.openMoment);
    });
    return nextOpenService;
};
export var getDispensaryHomePageUrl = function(dispensary, isEmbedded) {
    var isMobileEcommApp = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (isEmbedded) {
        return dispensary === null || dispensary === void 0 ? void 0 : dispensary.embeddedMenuUrl;
    }
    if (isMobileEcommApp) {
        return "/mobile-ecomm/".concat(dispensary === null || dispensary === void 0 ? void 0 : dispensary.cName);
    }
    return "/dispensary/".concat(dispensary === null || dispensary === void 0 ? void 0 : dispensary.cName);
};
/**
 * @param {Dispensary} dispensary
 * @returns {boolean}
 */ export var isMed = function(param) {
    var medicalDispensary = param.medicalDispensary;
    return medicalDispensary;
};
/**
 * @param {Dispensary} dispensary
 * @returns {boolean}
 */ export var isRec = function(param) {
    var recDispensary = param.recDispensary;
    return !!recDispensary;
};
/**
 * @param {Dispensary} dispensary
 * @returns {boolean}
 */ export var isAfterHoursCurrentlyAvailable = function(dispensary) {
    return acceptingAfterHoursForDelivery(dispensary) || acceptingAfterHoursForPickup(dispensary);
};
/**
 * @param {Dispensary} dispensary
 * @param {boolean} checkHideDeliveryEstimate
 * @returns {boolean}
 */ export var shouldHideOrderEstimates = function(dispensary, Cart) {
    var checkHideDeliveryEstimate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _dispensary_featureFlags, _dispensary_featureFlags1;
    var orderTypesConfigV2 = dispensary.orderTypesConfigV2;
    var isInStorePickup = Cart.isInStorePickup, isCurbsidePickup = Cart.isCurbsidePickup, isDriveThruPickup = Cart.isDriveThruPickup, isDelivery = Cart.isDelivery;
    var scheduledOrderingForPickup = isInStorePickup && (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : orderTypesConfigV2.inStorePickup.enableScheduledOrdering) || isCurbsidePickup && (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : orderTypesConfigV2.curbsidePickup.enableScheduledOrdering) || isDriveThruPickup && (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : orderTypesConfigV2.driveThruPickup.enableScheduledOrdering);
    var scheduledOrderingForDelivery = isDelivery && (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : orderTypesConfigV2.delivery.enableScheduledOrdering);
    return !!((dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_featureFlags = dispensary.featureFlags) === null || _dispensary_featureFlags === void 0 ? void 0 : _dispensary_featureFlags.hideStoreHours) || (scheduledOrderingForPickup || scheduledOrderingForDelivery) && Cart.reservation || checkHideDeliveryEstimate && (dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_featureFlags1 = dispensary.featureFlags) === null || _dispensary_featureFlags1 === void 0 ? void 0 : _dispensary_featureFlags1.hideDeliveryEstimate));
};
// If we are not given a max delivery distance then any is good.
// [maxDeliveryDistance] Float in Miles
// [distanceFromDispensary] Float in Meters
export var closeEnoughForDelivery = function(maxDeliveryDistance, distanceFromDispensary) {
    return !maxDeliveryDistance || parseFloat(maxDeliveryDistance) / 0.00062137 >= distanceFromDispensary;
};
/**
 * @param {Object}
 * @param {boolean} hasDeliveryAddress
 * @returns {string | false}
 */ export var getDeliveryFee = function(param) {
    var deliveryInfo = param.deliveryInfo, feeTiers = param.feeTiers, enabledOrderTypes = param.enabledOrderTypes, orderTypesConfig = param.orderTypesConfig, orderTypesConfigV2 = param.orderTypesConfigV2, hasDeliveryAddress = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var deliveryEnabled;
    if (enabledOrderTypes) {
        deliveryEnabled = enabledOrderTypes.delivery;
    } else if (orderTypesConfigV2) {
        var _orderTypesConfigV2_delivery, _orderTypesConfigV2_delivery1;
        deliveryEnabled = (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : (_orderTypesConfigV2_delivery = orderTypesConfigV2.delivery) === null || _orderTypesConfigV2_delivery === void 0 ? void 0 : _orderTypesConfigV2_delivery.enableASAPOrdering) || (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : (_orderTypesConfigV2_delivery1 = orderTypesConfigV2.delivery) === null || _orderTypesConfigV2_delivery1 === void 0 ? void 0 : _orderTypesConfigV2_delivery1.enableScheduledOrdering);
    } else {
        var _orderTypesConfig_delivery;
        deliveryEnabled = orderTypesConfig === null || orderTypesConfig === void 0 ? void 0 : (_orderTypesConfig_delivery = orderTypesConfig.delivery) === null || _orderTypesConfig_delivery === void 0 ? void 0 : _orderTypesConfig_delivery.enabled;
    }
    if (!deliveryEnabled) {
        return false;
    }
    if (!hasDeliveryAddress && (deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.feeVaries)) {
        return 'varies';
    }
    var _deliveryInfo_feeType;
    var feeType = (_deliveryInfo_feeType = deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.feeType) !== null && _deliveryInfo_feeType !== void 0 ? _deliveryInfo_feeType : 'flat';
    if (feeType === 'flat' && _.isFinite(deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.fee) && !((deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.fee) <= 0)) {
        return "".concat(formatCurrency(deliveryInfo.fee / 100, {
            trimZeroCents: true
        }));
    }
    if (feeType === 'percent' && _.isFinite(deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.percentFee) && !((deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.percentFee) <= 0)) {
        return "".concat(String(deliveryInfo.percentFee), "%");
    }
    if (!(feeTiers === null || feeTiers === void 0 ? void 0 : feeTiers.length)) {
        return false;
    }
    var firstFeeType = _.get(feeTiers, '0.feeType', 'flat');
    var firstFee = _.get(feeTiers, "0.".concat(firstFeeType === 'percent' ? 'percentFee' : 'fee'), '') || '';
    var parsedFee = firstFeeType !== 'percent' ? Number(firstFee) : parseFloat(firstFee.toString().replace(/[^\d.]/, ''));
    var hasDeliveryFee = _.isFinite(parsedFee) && parsedFee !== 0;
    var formattedFee = parsedFee % 1 === 0 ? parsedFee : parsedFee.toFixed(2);
    if (!hasDeliveryFee) {
        return false;
    }
    return firstFeeType === 'percent' ? "".concat(parsedFee, "%") : "".concat(formatCurrency(formattedFee, {
        trimZeroCents: true
    }));
};
/**
 * @typedef {import('types/graphql').GqlWeeklyHours} GqlWeeklyHours
 * @typedef {import('types/graphql').GqlSpecialHours} GqlSpecialHours
 *
 * @param {GqlWeeklyHours} hours
 * @param {DaysOfWeek} day
 * @param {boolean} lowercaseSuffix
 * @returns {string}
 */ export var getFormattedHoursForDay = function(hours, day) {
    var lowercaseSuffix = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _hours_day;
    var _ref = (_hours_day = hours[day]) !== null && _hours_day !== void 0 ? _hours_day : {}, active = _ref.active, start = _ref.start, end = _ref.end;
    var amSuffix = lowercaseSuffix ? 'am' : 'AM';
    var pmSuffix = lowercaseSuffix ? 'pm' : 'PM';
    if (!active) {
        return "".concat(day, " (Closed)");
    }
    if (start === 'open') {
        return "".concat(day, " (24 Hours)");
    }
    return "".concat(day, ": ").concat(start === null || start === void 0 ? void 0 : start.replace(/^00/, '12').replace(/:00 /i, '').replace(/ AM/i, amSuffix).replace(/ PM/i, pmSuffix), " -\n  ").concat(end === null || end === void 0 ? void 0 : end.replace(/:00 /i, '').replace(/ AM/i, amSuffix).replace(/ PM/i, pmSuffix));
};
export var getDeliveryMinimum = function(param) {
    var deliveryInfo = param.deliveryInfo, enabledOrderTypes = param.enabledOrderTypes, orderTypesConfig = param.orderTypesConfig, orderTypesConfigV2 = param.orderTypesConfigV2, hasDeliveryAddress = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var deliveryEnabled;
    if (enabledOrderTypes) {
        deliveryEnabled = enabledOrderTypes.delivery;
    } else if (orderTypesConfigV2) {
        var _orderTypesConfigV2_delivery, _orderTypesConfigV2_delivery1;
        deliveryEnabled = ((_orderTypesConfigV2_delivery = orderTypesConfigV2.delivery) === null || _orderTypesConfigV2_delivery === void 0 ? void 0 : _orderTypesConfigV2_delivery.enableASAPOrdering) || ((_orderTypesConfigV2_delivery1 = orderTypesConfigV2.delivery) === null || _orderTypesConfigV2_delivery1 === void 0 ? void 0 : _orderTypesConfigV2_delivery1.enableScheduledOrdering);
    } else {
        var _orderTypesConfig_delivery;
        deliveryEnabled = (_orderTypesConfig_delivery = orderTypesConfig.delivery) === null || _orderTypesConfig_delivery === void 0 ? void 0 : _orderTypesConfig_delivery.enabled;
    }
    if (!deliveryEnabled) {
        return false;
    }
    if (!hasDeliveryAddress && (deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.minimumVaries)) {
        return 'varies';
    }
    return _.isFinite(deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.minimum) && (deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.minimum) > 0 && (deliveryInfo === null || deliveryInfo === void 0 ? void 0 : deliveryInfo.minimum) / 100;
};
/*
 * This return the whole orderMinimum object that includes the minimumInCents and enabled fields
 */ export var getPickupMinimum = function(dispensary, pickupOrderType) {
    var _orderTypesConfigV2_orderTypeKey;
    var orderTypesConfigV2 = dispensary.orderTypesConfigV2;
    var orderTypeKey = pickupOrderType === 'pickup' ? 'inStorePickup' : pickupOrderType;
    if (!orderTypesConfigV2) {
        return null;
    }
    var minimum = (_orderTypesConfigV2_orderTypeKey = orderTypesConfigV2[orderTypeKey]) === null || _orderTypesConfigV2_orderTypeKey === void 0 ? void 0 : _orderTypesConfigV2_orderTypeKey.orderMinimum;
    return minimum;
};
/**
 * @param {boolean} isDelivery
 * @param {Dispensary} dispensary
 * @returns {number | string}
 */ export var getMinimumInDollars = function(isDelivery, dispensary) {
    var _getPickupMinimum;
    var _getPickupMinimum_minimumInCents;
    return isDelivery ? getDeliveryMinimum(dispensary, true) : Number.parseFloat((_getPickupMinimum_minimumInCents = (_getPickupMinimum = getPickupMinimum(dispensary, "inStorePickup")) === null || _getPickupMinimum === void 0 ? void 0 : _getPickupMinimum.minimumInCents) !== null && _getPickupMinimum_minimumInCents !== void 0 ? _getPickupMinimum_minimumInCents : 0) / 100;
};
export var getFirstAvailablePickupOption = function(dispensary) {
    var enabledOrderTypes = getEnabledV2OrderTypes(dispensary);
    if (_.includes(enabledOrderTypes, 'inStorePickup')) {
        return 'pickup';
    }
    if (_.includes(enabledOrderTypes, 'curbsidePickup')) {
        return 'curbsidePickup';
    }
    if (_.includes(enabledOrderTypes, 'driveThruPickup')) {
        return 'driveThruPickup';
    }
    return 'pickup';
};
export var formatDeliveryZoneInfo = function(dispensary, hasDeliveryAddress) {
    var fieldsHaveLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var fee = getDeliveryFee(dispensary, hasDeliveryAddress);
    var minimum = getDeliveryMinimum(dispensary, hasDeliveryAddress);
    var feeDisplay = fee ? "".concat(fee, " delivery fee") : "Free delivery";
    var minimumDisplay = minimum ? "".concat(formatCurrency(minimum, {
        trimZeroCents: true
    }), " delivery min.") : "No minimum";
    if (fee === 'varies') {
        feeDisplay = fieldsHaveLabel ? "Varies by location" : "Fee varies by location";
    }
    if (minimum === 'varies') {
        minimumDisplay = fieldsHaveLabel ? "Varies by location" : "Minimum varies by location";
    }
    var info = {
        feeDisplay: feeDisplay,
        minimumDisplay: minimumDisplay,
        fee: fee,
        minimum: minimum
    };
    if (fee === 'varies' && minimum === 'varies') {
        _.set(info, 'bothVary', 'Fees and minimums vary by location');
    }
    return info;
};
// Condensed version of the above delivery info formatting function
export var formatAmountMessage = function(amount, label) {
    var amtMessage;
    var formattedAmount = label === 'Minimum' ? "$".concat(amount) : amount;
    if (amount && amount !== '0') {
        amtMessage = "".concat(formattedAmount, " ").concat(label);
    }
    if (amount && amount === 'varies') {
        amtMessage = "".concat(label, " Varies");
    }
    if (!amount) {
        amtMessage = "No ".concat(label);
    }
    return amtMessage;
};
export var formatPickupInfo = function(dispensary, pickupOrderType) {
    var minimum = getPickupMinimum(dispensary, pickupOrderType);
    var pickupMinimum = (minimum === null || minimum === void 0 ? void 0 : minimum.minimumInCents) > 0 && (minimum === null || minimum === void 0 ? void 0 : minimum.enabled) ? "".concat(formatCurrency(minimum.minimumInCents / 100, {
        trimZeroCents: true
    }), " pickup min.") : 'No minimum';
    var info = {
        pickupMinimum: pickupMinimum
    };
    return info;
};
export var hasNonCashPaymentOptions = function(dispensaryProfile) {
    var ignoreDebit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var debitCard = ignoreDebit ? false : _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'debit', false);
    var linx = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'linx', false);
    var creditCardNoInfo = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'creditCardAtDoor', false);
    var creditCardByPhone = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'creditCardByPhone', false);
    var alt36 = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'alt36', false);
    var chaseOnline = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'payOnlineChase', false);
    var hypurOnline = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'payOnlineHypur', false);
    var merrcoOnline = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'payOnlineMerrco', false);
    var monerisOnline = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'payOnlineMoneris', false);
    var canPay = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'canPay', false);
    var paytender = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'paytender', false);
    var aeropay = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'aeropay', false);
    var check = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'check', false);
    var dutchiePay = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'dutchiePay', true);
    var rethinkPay = _.get(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.paymentTypesAccepted, 'rethinkPay', false);
    return linx || creditCardNoInfo || creditCardByPhone || debitCard || alt36 || chaseOnline || hypurOnline || canPay || merrcoOnline || monerisOnline || paytender || aeropay || check || dutchiePay || rethinkPay;
};
export var getAcceptedPaymentOptions = function(dispensary) {
    var _$_;
    if (!dispensary) {
        return {
            cash: true,
            debit: false,
            credit: false
        };
    }
    // get a list of all payment types enabled for any enabled order type, excluding kiosk
    var orderTypesConfigV2 = dispensary.orderTypesConfigV2;
    var cleanConfigs = removeTypename(orderTypesConfigV2);
    var nonKioskConfigs = _.filter(_.omit(cleanConfigs, 'kiosk'), function(config) {
        return config.enableASAPOrdering || config.enableScheduledOrdering;
    });
    var nonKioskPaymentTypes = _.map(nonKioskConfigs, "paymentTypes");
    var acceptedPaymentTypes = _.pickBy((_$_ = _).assignInWith.apply(_$_, [
        {}
    ].concat(_to_consumable_array(nonKioskPaymentTypes), [
        function(a, b) {
            return a || b;
        }
    ])));
    return acceptedPaymentTypes;
};
export var getPaymentFeeForMethod = function(paymentMethod) {
    var paymentFees = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return _.find(paymentFees, function(feeEntry) {
        return feeEntry.paymentType === paymentMethod || feeEntry.paymentType === 'creditCardAtDoor' && paymentMethod === 'creditCard' || feeEntry.paymentType === 'debit' && paymentMethod === 'debitCard' || feeEntry.paymentType === 'debitOnly' && paymentMethod === 'debitCard' || feeEntry.paymentType === 'debitOnly' && paymentMethod === 'debit';
    });
};
export var dispensaryOpenStatus = function(dispensary, openInfo) {
    var pickup = openInfo.pickup, delivery = openInfo.delivery;
    if (pickup.isOpen || delivery.isOpen) {
        return 'open';
    }
    if (pickup.isClosed && dispensary.offerAnyPickupService && dispensary.storeSettings.enableAfterHoursOrderingForPickup) {
        return 'closedButAfterHours';
    }
    return 'closed';
};
export var dispensaryStatusForUser = function(dispensary, openInfo) {
    var inDeliveryRange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var orderTypesConfigV2 = dispensary.orderTypesConfigV2;
    var _ref = orderTypesConfigV2 || {}, offerAnyPickupService = _ref.offerAnyPickupService, offerDeliveryService = _ref.offerDeliveryService;
    var inStorePickup = openInfo.inStorePickup, curbsidePickup = openInfo.curbsidePickup, driveThruPickup = openInfo.driveThruPickup, delivery = openInfo.delivery;
    var pickupIsOpen = inStorePickup.isOpen || curbsidePickup.isOpen || driveThruPickup.isOpen;
    var afterHoursForPickup = acceptingAfterHoursForPickup(dispensary);
    var afterHoursForDelivery = acceptingAfterHoursForDelivery(dispensary);
    var nextOpenService = getNextOpenService(dispensary, openInfo);
    var _openInfo_nextOpenService_nextService_openString;
    var nextOpenServiceString = (_openInfo_nextOpenService_nextService_openString = openInfo[nextOpenService].nextService.openString) !== null && _openInfo_nextOpenService_nextService_openString !== void 0 ? _openInfo_nextOpenService_nextService_openString : 'Next service opportunity unknown';
    var useOpensAt = nextOpenServiceString.search('unknown') === -1;
    if (!offerAnyPickupService && !offerDeliveryService) {
        return 'This dispensary is currently closed.';
    }
    if (offerDeliveryService && delivery.isOpen && !pickupIsOpen && afterHoursForPickup) {
        return 'Delivery available, Pickup available for pre-order';
    }
    if (offerAnyPickupService && pickupIsOpen && delivery.isClosed && afterHoursForDelivery) {
        return 'Pickup available, Delivery available for pre-order';
    }
    if (!pickupIsOpen && delivery.isClosed && (afterHoursForPickup || afterHoursForDelivery)) {
        var afterHourOrderTypesAvailable = function() {
            if (afterHoursForPickup && afterHoursForDelivery) {
                return '';
            }
            if (afterHoursForDelivery) {
                return ' Delivery';
            }
            return ' Pickup';
        }();
        return "Closed,".concat(afterHourOrderTypesAvailable, " available for pre-order");
    }
    if (!pickupIsOpen && (!offerDeliveryService || delivery.isClosed)) {
        return "Closed.".concat(useOpensAt ? ' Opens at' : '', " ").concat(nextOpenServiceString);
    }
    if (offerDeliveryService && inDeliveryRange) {
        if (delivery.isOpen && pickupIsOpen) {
            return 'Delivery + Pickup available';
        }
        if (delivery.isOpen && !offerAnyPickupService) {
            return 'Delivery available';
        }
        if (delivery.isClosed && pickupIsOpen) {
            return 'Delivery closed, Pickup available';
        }
        if (offerAnyPickupService && !pickupIsOpen && delivery.isOpen) {
            return 'Delivery available, Pickup closed';
        }
    }
    if (pickupIsOpen) {
        return 'Pickup available';
    }
    if (offerDeliveryService && !inDeliveryRange) {
        return 'Delivery unavailable';
    }
    return "".concat(useOpensAt ? 'Opens at' : '', " ").concat(nextOpenServiceString);
};
// this is just used to return the first available open pickup type
export var openInfoForPickup = function(openInfo) {
    var pickupInfo = openInfo.inStorePickup;
    var otherPickupTypesInfo = _.pick(openInfo, [
        'curbsidePickup',
        'driveThruPickup'
    ]);
    if (pickupInfo === null || pickupInfo === void 0 ? void 0 : pickupInfo.isClosed) {
        pickupInfo = _.head(_.toPairs(_.pickBy(otherPickupTypesInfo, [
            'isOpen',
            true
        ])));
    }
    return _.isEmpty(pickupInfo) || !pickupInfo[0] ? {
        type: 'inStorePickup',
        info: openInfo.inStorePickup
    } : {
        type: pickupInfo[0],
        info: pickupInfo[1]
    };
};
// The next set of helpers is used to determine if after-hours
// or scheduled ordering is enabled for a dispensary.
export var scheduledOrderingEnabledForDelivery = function(dispensary) {
    var _dispensary_orderTypesConfigV2_delivery, _dispensary_orderTypesConfigV2;
    if (!dispensary) {
        return false;
    }
    return (_dispensary_orderTypesConfigV2 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV2 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_delivery = _dispensary_orderTypesConfigV2.delivery) === null || _dispensary_orderTypesConfigV2_delivery === void 0 ? void 0 : _dispensary_orderTypesConfigV2_delivery.enableScheduledOrdering;
};
export var scheduledOrderingEnabledForPickup = function(dispensary) {
    var _dispensary_orderTypesConfigV2_inStorePickup, _dispensary_orderTypesConfigV2, _dispensary_orderTypesConfigV2_curbsidePickup, _dispensary_orderTypesConfigV21, _dispensary_orderTypesConfigV2_driveThruPickup, _dispensary_orderTypesConfigV22;
    if (!dispensary) {
        return false;
    }
    return ((_dispensary_orderTypesConfigV2 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV2 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_inStorePickup = _dispensary_orderTypesConfigV2.inStorePickup) === null || _dispensary_orderTypesConfigV2_inStorePickup === void 0 ? void 0 : _dispensary_orderTypesConfigV2_inStorePickup.enableScheduledOrdering) || ((_dispensary_orderTypesConfigV21 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV21 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_curbsidePickup = _dispensary_orderTypesConfigV21.curbsidePickup) === null || _dispensary_orderTypesConfigV2_curbsidePickup === void 0 ? void 0 : _dispensary_orderTypesConfigV2_curbsidePickup.enableScheduledOrdering) || ((_dispensary_orderTypesConfigV22 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV22 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_driveThruPickup = _dispensary_orderTypesConfigV22.driveThruPickup) === null || _dispensary_orderTypesConfigV2_driveThruPickup === void 0 ? void 0 : _dispensary_orderTypesConfigV2_driveThruPickup.enableScheduledOrdering);
};
export var afterHoursEnabledForDelivery = function(dispensary) {
    var _dispensary_orderTypesConfigV2_delivery, _dispensary_orderTypesConfigV2;
    if (!dispensary) {
        return false;
    }
    return (_dispensary_orderTypesConfigV2 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV2 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_delivery = _dispensary_orderTypesConfigV2.delivery) === null || _dispensary_orderTypesConfigV2_delivery === void 0 ? void 0 : _dispensary_orderTypesConfigV2_delivery.enableAfterHoursOrdering;
};
export var afterHoursEnabledForPickup = function(dispensary) {
    var _dispensary_orderTypesConfigV2_inStorePickup, _dispensary_orderTypesConfigV2, _dispensary_orderTypesConfigV2_curbsidePickup, _dispensary_orderTypesConfigV21, _dispensary_orderTypesConfigV2_driveThruPickup, _dispensary_orderTypesConfigV22;
    if (!dispensary) {
        return false;
    }
    return ((_dispensary_orderTypesConfigV2 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV2 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_inStorePickup = _dispensary_orderTypesConfigV2.inStorePickup) === null || _dispensary_orderTypesConfigV2_inStorePickup === void 0 ? void 0 : _dispensary_orderTypesConfigV2_inStorePickup.enableAfterHoursOrdering) || ((_dispensary_orderTypesConfigV21 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV21 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_curbsidePickup = _dispensary_orderTypesConfigV21.curbsidePickup) === null || _dispensary_orderTypesConfigV2_curbsidePickup === void 0 ? void 0 : _dispensary_orderTypesConfigV2_curbsidePickup.enableAfterHoursOrdering) || ((_dispensary_orderTypesConfigV22 = dispensary.orderTypesConfigV2) === null || _dispensary_orderTypesConfigV22 === void 0 ? void 0 : (_dispensary_orderTypesConfigV2_driveThruPickup = _dispensary_orderTypesConfigV22.driveThruPickup) === null || _dispensary_orderTypesConfigV2_driveThruPickup === void 0 ? void 0 : _dispensary_orderTypesConfigV2_driveThruPickup.enableAfterHoursOrdering);
};
// The next set of helpers is used to determine if a dispensary should currently be taking after hours
// orders, based on the current hours settings and whether after-hours or scheduled ordering are enabled.
export var acceptingAfterHoursForDelivery = function(dispensary) {
    if (!dispensary) {
        return false;
    }
    var orderTypesConfigV2 = dispensary.orderTypesConfigV2, status = dispensary.status;
    var afterHoursDeliveryEnabled = afterHoursEnabledForDelivery(dispensary);
    var scheduledDeliveryEnabled = scheduledOrderingEnabledForDelivery(dispensary);
    var _openInfoForDispensary = openInfoForDispensary(dispensary, {}), deliveryOpenInfoV2 = _openInfoForDispensary.delivery;
    return status === 'open' && orderTypesConfigV2.offerDeliveryService && deliveryOpenInfoV2.isClosed && deliveryOpenInfoV2.nextService.openMoment && afterHoursDeliveryEnabled && scheduledDeliveryEnabled;
};
export var acceptingAfterHoursForPickup = function(dispensary) {
    var _orderTypesConfigV2_inStorePickup, _orderTypesConfigV2_curbsidePickup, _orderTypesConfigV2_driveThruPickup;
    if (!dispensary) {
        return false;
    }
    var orderTypesConfigV2 = dispensary.orderTypesConfigV2, status = dispensary.status;
    var offerAnyPickupService = orderTypesConfigV2.offerAnyPickupService;
    var _openInfoForDispensary = openInfoForDispensary(dispensary, {}), inStorePickup = _openInfoForDispensary.inStorePickup, curbsidePickup = _openInfoForDispensary.curbsidePickup, driveThruPickup = _openInfoForDispensary.driveThruPickup;
    var inStoreOpenForPreOrder = inStorePickup.isClosed && (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : (_orderTypesConfigV2_inStorePickup = orderTypesConfigV2.inStorePickup) === null || _orderTypesConfigV2_inStorePickup === void 0 ? void 0 : _orderTypesConfigV2_inStorePickup.enableAfterHoursOrdering) && inStorePickup.nextService.openMoment;
    var curbsideOpenForPreOrder = curbsidePickup.isClosed && (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : (_orderTypesConfigV2_curbsidePickup = orderTypesConfigV2.curbsidePickup) === null || _orderTypesConfigV2_curbsidePickup === void 0 ? void 0 : _orderTypesConfigV2_curbsidePickup.enableAfterHoursOrdering) && curbsidePickup.nextService.openMoment;
    var driveThruOpenForPreOrder = driveThruPickup.isClosed && (orderTypesConfigV2 === null || orderTypesConfigV2 === void 0 ? void 0 : (_orderTypesConfigV2_driveThruPickup = orderTypesConfigV2.driveThruPickup) === null || _orderTypesConfigV2_driveThruPickup === void 0 ? void 0 : _orderTypesConfigV2_driveThruPickup.enableAfterHoursOrdering) && driveThruPickup.nextService.openMoment;
    var afterHoursPickupEnabled = inStoreOpenForPreOrder || curbsideOpenForPreOrder || driveThruOpenForPreOrder;
    return status === 'open' && offerAnyPickupService && afterHoursPickupEnabled;
};
var formatTime = function(timeStr) {
    return (timeStr || '').replace(/^00/, '12').replace(' ', '').replace(':00', '').replace('AM', 'am').replace('PM', 'pm');
};
export var dispensaryHoursForDay = function(day) {
    if (_.isUndefined(day)) {
        return 'Closed';
    }
    var active = day.active, start = day.start, end = day.end;
    if (!active) {
        return 'Closed';
    }
    if (start === 'open' && end === 'open') {
        return 'Open 24 Hours';
    }
    if (start === end) {
        return 'Closed';
    }
    return "".concat(formatTime(day.start), " - ").concat(formatTime(day.end));
};
export var getEffectiveHoursForOrderType = function(operatingHoursForType, specialHoursForType, timezone) {
    var effectiveHours = {};
    var specialHoursDays = getSpecialHoursDays(specialHoursForType, timezone);
    var specialHoursThisWeek = _.filter(specialHoursDays, function(param) {
        var date = param.date;
        return moment.tz(date, timezone).isSame(moment().tz(timezone), 'week');
    });
    if (specialHoursThisWeek) {
        _.forEach(specialHoursThisWeek, function(day) {
            _.set(effectiveHours, moment.tz(day.date, timezone).format('dddd'), day.hours);
        });
    }
    return _object_spread({}, operatingHoursForType, effectiveHours);
};
export function clearDependentSettingsIfFeatureDisabled(param) {
    var profile = param.profile;
    _.forEach(_.keys(mutuallyInclusiveFeatures), function(key) {
        var feature = mutuallyInclusiveFeatures[key];
        var featureEnabled = _.get(profile, feature.path, false);
        if (!featureEnabled) {
            _.forEach(feature.dependentSettingPaths, function(path) {
                _.set(profile, path, false);
            });
        }
    });
}
export function generateAcceptedPaymentsString(dispensary) {
    var _dispensary_paymentTypesAccepted = dispensary.paymentTypesAccepted, credit = _dispensary_paymentTypesAccepted.credit, debit = _dispensary_paymentTypesAccepted.debit, cash = _dispensary_paymentTypesAccepted.cash, check = _dispensary_paymentTypesAccepted.check, linx = _dispensary_paymentTypesAccepted.linx, canPay = _dispensary_paymentTypesAccepted.canPay, paytender = _dispensary_paymentTypesAccepted.paytender, aeropay = _dispensary_paymentTypesAccepted.aeropay, dutchiePay = _dispensary_paymentTypesAccepted.dutchiePay, rethinkPay = _dispensary_paymentTypesAccepted.rethinkPay;
    var paymentOpts = [];
    if (cash) {
        paymentOpts.push('Cash');
    }
    if (credit) {
        paymentOpts.push('Credit');
    }
    if (debit) {
        paymentOpts.push('Debit');
    }
    if (check) {
        paymentOpts.push('Check');
    }
    if (linx) {
        paymentOpts.push('Linx');
    }
    if (canPay) {
        paymentOpts.push('CanPay');
    }
    if (paytender) {
        paymentOpts.push('Paytender');
    }
    if (aeropay) {
        paymentOpts.push('Aeropay');
    }
    if (dutchiePay) {
        paymentOpts.push('dutchiePay');
    }
    if (rethinkPay) {
        paymentOpts.push('rethinkPay');
    }
    return paymentOpts.length >= 1 ? paymentOpts.join(', ') : 'Cash';
}
export var getCategoryPhoto = function(dispensaryProfile) {
    var category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var __find, __find1, _dispensaryProfile_webCustomizationSettingsV2_categories, _dispensaryProfile_webCustomizationSettingsV2, _dispensaryProfile_location;
    var photoFromDispensaryProfile = (__find = _.find(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : dispensaryProfile.categoryPhotos, {
        category: category.value
    })) === null || __find === void 0 ? void 0 : __find.src;
    var v2CategoryPhoto = (__find1 = _.find(dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : (_dispensaryProfile_webCustomizationSettingsV2 = dispensaryProfile.webCustomizationSettingsV2) === null || _dispensaryProfile_webCustomizationSettingsV2 === void 0 ? void 0 : (_dispensaryProfile_webCustomizationSettingsV2_categories = _dispensaryProfile_webCustomizationSettingsV2.categories) === null || _dispensaryProfile_webCustomizationSettingsV2_categories === void 0 ? void 0 : _dispensaryProfile_webCustomizationSettingsV2_categories.items, {
        category: category.value
    })) === null || __find1 === void 0 ? void 0 : __find1.image;
    var defaultPhoto = (dispensaryProfile === null || dispensaryProfile === void 0 ? void 0 : (_dispensaryProfile_location = dispensaryProfile.location) === null || _dispensaryProfile_location === void 0 ? void 0 : _dispensaryProfile_location.state) === 'UT' && category.value === 'Edible' ? 'https://images.dutchie.com/category-stock-photos/edibles/edibles-gummies.png' : defaultCategoryPhotos[category.value];
    var _ref;
    return (_ref = v2CategoryPhoto !== null && v2CategoryPhoto !== void 0 ? v2CategoryPhoto : photoFromDispensaryProfile) !== null && _ref !== void 0 ? _ref : defaultPhoto;
};
export var getOrderTypesWithDutchiePayEnabled = function(dispensary) {
    var excludeKiosk = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var orderTypesConfigV2 = (dispensary !== null && dispensary !== void 0 ? dispensary : {}).orderTypesConfigV2;
    var _removeTypename;
    var cleanConfigs = (_removeTypename = removeTypename(orderTypesConfigV2)) !== null && _removeTypename !== void 0 ? _removeTypename : {};
    return Object.keys(cleanConfigs).filter(function(key) {
        var _section_paymentTypes;
        var section = cleanConfigs[key];
        if (excludeKiosk && key === 'kiosk') {
            return false;
        }
        return (section === null || section === void 0 ? void 0 : (_section_paymentTypes = section.paymentTypes) === null || _section_paymentTypes === void 0 ? void 0 : _section_paymentTypes.dutchiePay) === true;
    });
};
